// extracted by mini-css-extract-plugin
module.exports = {"s1jc0l42":"s1jc0l42","trcm2aw":"trcm2aw","m1plcq7c":"m1plcq7c","spin":"spin"};